import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { TemplateType } from '@/modules/types/template';

export const templateAdapter = createEntityAdapter();

const initialState: TemplateType = templateAdapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  data: null,
});

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    fetch: (state) => {
      state.isLoaded = false;
      state.isLoading = true;
      state.data = null;
    },
    fetchSuccess: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.data = action.payload.data.data;
    },
    fetchFailure: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.error = action.payload.error;
    },
  },
});

export const { name, actions, reducer } = templateSlice;
